// extracted by mini-css-extract-plugin
module.exports = {"signupForm":"SignupForm_signupForm__1ufaw","step-1":"SignupForm_step-1__RjjXj","fadeIn":"SignupForm_fadeIn__2PUGi","scaleXin":"SignupForm_scaleXin__1x-ew"};